import cloneDeep from 'lodash.clonedeep';
import CustomEvent from 'custom-event';

const view = {
  container: null,
  template: null,
  el: null,

  isRendered() {
    return this.el !== null && this.el !== undefined;
  },

  isVisible() {
    return this.isRendered() && this.el.classList.contains('visible');
  },

  show() {
    if (!this.isRendered()) {
      return Promise.reject(new Error('View must be rendered'));
    }

    const showView = () => {
      this.el.classList.add('visible');
    };

    return Promise.resolve()
      .then(showView);
  },

  hide() {
    if (!this.isRendered()) {
      return Promise.reject(new Error('View must be rendered'));
    }

    const hideView = () => {
      this.el.classList.remove('visible');
    };

    return Promise.resolve()
      .then(hideView);
  },

  open() {
    if (!this.isRendered()) {
      return this.render()
        .then(() => this.show());
    }

    return !this.isVisible() ? this.show() : Promise.resolve();
  },

  close() {
    if (!this.isRendered()) {
      return Promise.resolve();
    }

    const hide = this.isVisible() ? this.hide() : Promise.resolve();

    return hide.then(() => this.destroy());
  },

  addEventListener() {
    this.el.addEventListener.apply(this.el, arguments);
  },

  dispatchEvent(name) {
    const event = new CustomEvent(name);

    this.el.dispatchEvent(event);
  },

  render() {
    if (!this.template) {
      return Promise.reject(new Error('View must have a template'));
    }

    if (!this.container) {
      return Promise.reject(new Error('View must have a container'));
    }

    const renderMarkup = () => {
      const html = this.template(this.getContext());

      this.container.insertAdjacentHTML('beforeend', html);

      this.el = this.container.lastElementChild;
      this.el.view = this;
    };

    return Promise.resolve()
      .then(renderMarkup);
  },

  destroy() {
    if (!this.isRendered()) {
      return;
    }

    this.container.removeChild(this.el);

    this.el = null;
  },

  getContext() {
    return null;
  },
};

const make = cloneDeep.bind(null, view);

export default {
  make,
};
